/**
 * The status of an organization's CDS instance
 */ export var CdsProvisionState = /*#__PURE__*/ function(CdsProvisionState) {
    CdsProvisionState["NotAvailable"] = "NotAvailable";
    CdsProvisionState["Provisioning"] = "Provisioning";
    CdsProvisionState["Ready"] = "Ready";
    CdsProvisionState["Failed"] = "Failed";
    return CdsProvisionState;
}({});
